// export const GOOGLE_CLIENT_ID = "804706323424-blhfp7q4a4kalcoccpp9drbi66ek93oh.apps.googleusercontent.com"


export const GOOGLE_CLIENT_ID = "648348734259-7muerudv4se1spidifrd706duvke9062.apps.googleusercontent.com"
